import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  otpError: null,
  message: null,
  loading: false,
  user: null,
  success: false,
  error: false
};


const otpSlice = createSlice({
    name: "profile",
    initialState,
    reducers: {
      otpSuccessful(state, action) {
        state.user = action.payload;
        state.loading = false;
        state.success = true;
        state.registrationError = null;
      },
     otpUserFailed(state, action) {
        state.user = null;
        state.loading = false;
        state.registrationError = action.payload;
        state.error = true;
      },
      otpFlagChange(state) {
        state.success = false;
        state.error = false;
      },
      apiErrorChange(state, action){
        state.error = action.payload;
        state.loading = false;
        state.isUserLogout = false;
      }
    }
  });


  export const {
    otpSuccessful,
    otpUserFailed,
    otpFlagChange,
    apiErrorChange
  } = otpSlice.actions;
  
  export default otpSlice.reducer;